import React from 'react';
import { Box, Typography, Stack, Paper, IconButton } from '@mui/material';
import { AttachFile, Delete as DeleteIcon } from '@mui/icons-material';
import { FileWithPreview } from '../hooks';
import { formatFileSize } from '../constants';

interface SelectedFilesSectionProps {
  selectedFiles: FileWithPreview[];
  isUploading: boolean;
  onRemoveFile: (fileId: string) => void;
}

export const SelectedFilesSection: React.FC<SelectedFilesSectionProps> = ({
  selectedFiles,
  isUploading,
  onRemoveFile,
}) => {
  if (selectedFiles.length === 0) return null;

  return (
    <Box>
      <Typography variant="subtitle2" sx={{ mb: 2, fontWeight: 600, color: '#1e293b' }}>
        Selected Files ({selectedFiles.length})
      </Typography>

      <Stack spacing={1}>
        {selectedFiles.map((fileWithPreview) => (
          <Paper
            key={fileWithPreview.id}
            sx={{
              p: 2,
              display: 'flex',
              alignItems: 'center',
              gap: 2,
              backgroundColor: '#f8fafc',
              border: '1px solid #e2e8f0',
            }}
          >
            <AttachFile sx={{ color: '#64748b' }} />
            <Box sx={{ flex: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>
                {fileWithPreview.file.name}
              </Typography>
              <Typography variant="caption" sx={{ color: '#64748b' }}>
                {formatFileSize(fileWithPreview.file.size)}
              </Typography>
            </Box>
            <IconButton
              size="small"
              onClick={() => onRemoveFile(fileWithPreview.id)}
              disabled={isUploading}
              sx={{ color: '#dc2626' }}
            >
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Paper>
        ))}
      </Stack>
    </Box>
  );
};

export default SelectedFilesSection;
